module.exports = __webpack_public_path__ + "static/media/Lentes de contacto.2b88f75b.svg";